import { MdWarning } from "react-icons/md";

interface MealOutOfStockPopupProps {
  open: boolean;
  message?: string | null;
  onClose: () => void;
}

const MealOutOfStockPopup = ({
  open,
  message,
  onClose,
}: MealOutOfStockPopupProps) => {
  if (!open) {
    return null;
  }

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/40 px-5">
      <div className="w-full max-w-[320px] rounded-[28px] bg-white px-6 pb-6 pt-8 shadow-xl">
        <div className="flex flex-col items-center">
          <MdWarning className="text-[72px] text-[#F0524A]" />

          <p className="mt-4 text-[17px] font-bold text-[#333]">Stok Habis</p>

          <p className="mt-4 text-center text-[13px] leading-relaxed text-[#b3b3c2]">
            {message?.trim() || "Tidak ada sisa makanan reguler maupun spare."}
          </p>

          <p className="mt-3 text-center text-[13px] leading-relaxed text-[#b3b3c2]">
            Silahkan hubungi Sustainability untuk alokasi makanan.
          </p>

          <button
            type="button"
            onClick={onClose}
            className="mt-6 flex h-11 w-full items-center justify-center rounded-xl border border-[#d9d9e6] text-[13px] font-semibold text-[#8b8fa3] transition active:scale-[0.98]"
          >
            Tutup
          </button>
        </div>
      </div>
    </div>
  );
};

export default MealOutOfStockPopup;
